import { useMutation, useQueryClient } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';
import { FINDING_BY_ID_QUERY_KEY } from './useFindingById';
import { FINDINGS_QUERY_KEY } from './useFindings';
import { FINDING_AUDIT_LOGS_QUERY_KEY } from '../useFindingAuditLogs';
import { FINDING_TIMELINE_QUERY_KEY } from '../useFindingTimeline';

export const useRequestFindingRetest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ findingId }: { findingId: string }) =>
      terraProxyApiClient.requestFindingRetest(findingId),
    onSuccess: (_, variables) => {
      void Promise.all([
        queryClient.invalidateQueries({
          queryKey: [FINDING_BY_ID_QUERY_KEY, variables.findingId],
          exact: false,
        }),
        queryClient.invalidateQueries({
          queryKey: [FINDINGS_QUERY_KEY],
          exact: false,
        }),
        queryClient.invalidateQueries({
          queryKey: [FINDING_AUDIT_LOGS_QUERY_KEY, variables.findingId],
          exact: false,
        }),
        queryClient.invalidateQueries({
          queryKey: [FINDING_TIMELINE_QUERY_KEY, variables.findingId],
          exact: false,
        }),
      ]);
    },
  });
};
